import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IRehabItem, IRehabSection, RehabPanel } from '../property-rehab-calculator.page';
import { AlertController } from '@ionic/angular';

@Component({
    selector: 'app-rehab-calculator-box',
    templateUrl: './rehab-calculator-box.component.html',
    styleUrls: ['./rehab-calculator-box.component.scss']
})
export class RehabCalculatorBoxComponent implements OnInit {
    @Input() panel!: IRehabSection;
    @Input() key!: RehabPanel;
    @Input() expanded!: boolean;
    @Input() disabled!: boolean;
    @Input() readonly!: boolean;
    @Input() subtotal!: number;
    @Input() isPublic: boolean = false;
    @Output() panelChanged: EventEmitter<{ panel: RehabPanel, recalculate: boolean }> = new EventEmitter<{ panel: RehabPanel, recalculate: boolean }>();

    public inTitleEditMode = false;

    constructor(private alertController: AlertController) {
    }

    ngOnInit() {

    }

    onInputChange() {
        this.panelChanged.emit({ panel: this.key, recalculate: true });
    }

    addCost() {
        this.panel.items.push({
            label: 'New Cost',
            value: '',
            value2: null,
            notes: '',
            custom: true,
            inEditMode: true
        });

        this.panelChanged.emit({ panel: this.key, recalculate: true });
    }

    deleteCost(index: number) {
        this.panel.items.splice(index, 1);
        this.panelChanged.emit({ panel: this.key, recalculate: true });
    }

    async openAddNoteModal(index: number, notes = '') {
        if (this.readonly) {
            return;
        }

        const alert = await this.alertController.create({
            header: 'Add Note',
            cssClass: ['vesta-alert', 'vesta-alert--with-input'],
            buttons: ['OK'],
            inputs: [
                {
                    type: 'textarea',
                    placeholder: 'Type here',
                    value: notes
                },
            ]
        });

        await alert.present();

        const { data } = await alert.onDidDismiss();

        if (data) {
            this.panel.items[index].notes = data.values[0];
            this.panelChanged.emit({ panel: this.key, recalculate: false });
        }
    }

    changeTitle(event: any) {
        if (this.readonly) {
            return;
        }

        event.stopPropagation();
        this.inTitleEditMode = true;
    }

    onTitleChange(event: any) {
        event.stopPropagation();
    }

    editLabel(item: IRehabItem) {
        if (this.readonly || !item.custom) {
            return;
        }

        item.inEditMode = true;
    }

    changeInEditMode(item: IRehabItem) {
        setTimeout(() => {
            item.inEditMode = false;
        }, 0);
    }
}
